<template>
  <div>
    <v-container>
      <div class="pa-1 mt-4">
        <v-layout class="mb-2">
          <v-flex>
            <h2 class="title grey--text mt-2">Admin Users</h2>
          </v-flex>
          <div>
            <v-btn outline depressed color="primary" @click="showAdminManageDialog = true">
              <v-icon small>add</v-icon>Add
            </v-btn>
            <v-btn depressed color="primary" @click="showSearch = true" class="ma-0 mr-1">
              Filter/Search
            </v-btn>
          </div>
        </v-layout>
        <v-data-table
          :headers="headers"
          :pagination.sync="pagination"
          :items="adminData"
          class="elevation-1"
          :loading="loading"
          hide-actions
        >
          <template slot="headerCell" slot-scope="props">
            <HeaderTableWithSort
              :headers="props.header"
              :sortBy.sync="sortBy"
              :orderBy.sync="orderBy"
              @onSort="handleChangeSort"
            ></HeaderTableWithSort>
          </template>
          <template v-slot:items="props">
            <td>{{ props.item.name }}</td>
            <td>
              <change-password :userid="props.item.adminid"></change-password>
            </td>
            <td>{{ getRoleName(props.item.privilege) }}</td>
            <td>{{ getBranchName(props.item.admingroupid) }}</td>
            <td>
              <span v-if="props.item.is_connect" class="green--text">เชื่อมต่อแล้ว</span>
              <span v-else class="grey--text">ยังไม่ได้เชื่อมต่อ</span>
            </td>
            <td>
              <v-btn outline fab small color="primary" @click="handleEditAdmin(props.item)">
                <v-icon>edit</v-icon>
              </v-btn>
              <v-btn
                outline
                fab
                small
                color="primary"
                @click="handleDeleteAdmin(props.item.adminid)"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </div>
      <div class="mt-2">
        <v-pagination
          :total-visible="6"
          v-model="pageNumber"
          @input="changePage"
          :length="pagelength"
        ></v-pagination>
      </div>

      <v-dialog v-model="showAdminManageDialog" persistent width="600px">
        <AdminManageDialog
          v-if="showAdminManageDialog"
          v-model="selectedAdmin"
          @close="handleCloseDialog"
          @success="handleSuccess"
          :branchList="branchList"
        ></AdminManageDialog>
      </v-dialog>
    </v-container>
    <v-dialog v-model="showSearch" persistent width="800px">
      <SearchAdminDialog @close="handleCloseSearch" @onSearch="onSearch" />
    </v-dialog>
  </div>
</template>

<script>
import yasaleAcApi from '@/api/yasale-ac'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'
import importxlsx from '@/components/elements/importxlsx.vue'
import Sortable from '@/components/elements/Sortable.vue'
import AdminManageDialog from './AdminManageDialog.vue'
import ChangePassword from './ChangePassword.vue'
import SearchAdminDialog from './SearchAdminDialog.vue'
import HeaderTableWithSort from '@/components/elements/HeaderTableWithSort.vue'
import { ORDER_BY } from '@/constants/orderBy.js'

export default {
  components: {
    importxlsx,
    AdminManageDialog,
    ChangePassword,
    SearchAdminDialog,
    Sortable,
    HeaderTableWithSort
  },
  data() {
    return {
      filter: {},
      limit: 10,
      offset: 0,
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      pagetmp: 1,
      pageNumber: 1,
      importLoading: false,
      showAdminManageDialog: false,
      loading: false,
      adminData: [],
      showSearch: false,
      headers: [
        { text: 'Username', value: 'name', customSort: true, sortable: false },
        { text: 'Password', customSort: false, sortable: false },
        { text: 'Role', value: 'privilege', customSort: true, sortable: false },
        { text: 'ศูนย์', value: 'admingroupid', customSort: true, sortable: false },
        { text: 'สถานะการเชื่อมต่อไลน์', value: 'is_connect', customSort: true, sortable: false },
        { text: '', customSort: false, sortable: false }
      ],
      selectedAdmin: null,
      branchList: [],
      sortBy: 'name',
      orderBy: ORDER_BY.DESC
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        let total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  async mounted() {
    await this.handleInitial()
    await this.handleGetAdmin()
  },
  methods: {
    async handleInitial() {
      const vm = this
      try {
        const response = await yasaleAcApi.getBranchOptions({
          config: {
            params: {
              page_id: vm.selectedBot.pageid
            }
          }
        })

        if (response && response.status === 200) {
          vm.branchList = response.data.data
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    async handleGetAdmin() {
      const vm = this
      try {
        const response = await vm.getAdmin()
        if (response) {
          vm.adminData = response.data
          vm.total = response.total
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    async getAdmin() {
      const vm = this
      return new Promise(async (resolve, reject) => {
        const limit = vm.isExport ? vm.total : vm.limit
        let data = {
          page_id: vm.selectedBot.pageid,
          limit: limit,
          offset: vm.offset,
          sort_by: vm.sortBy,
          order_by: vm.orderBy,
          ...vm.filter
        }
        vm.loading = true
        const response = await yasaleAcApi.getAdminUser({
          config: {
            params: data
          }
        })

        vm.loading = false
        if (response && response.status === 200) {
          resolve(response.data)
        } else {
          reject(null)
        }
      })
    },
    handleEditAdmin(item) {
      const vm = this
      vm.selectedAdmin = item
      vm.showAdminManageDialog = true
    },
    handleDeleteAdmin(adminId) {
      this.$swal
        .fire({
          icon: 'error',
          text: 'คุณต้องการลบใช่หรือไม่',
          showCancelButton: true,
          cancelButtonText: 'ยกเลิก',
          confirmButtonText: 'ตกลง'
        })
        .then((result) => {
          if (result.value) {
            this.deleteAdmin(adminId)
          }
        })
    },
    async deleteAdmin(adminId) {
      const vm = this
      try {
        let data = {
          userid: adminId,
          pageid: vm.selectedBot.pageid
        }
        const response = await yasaleAcApi.deleteAdminUser({ data: data })
        if (response && response.status === 200) {
          await vm.$swal.fire({
            text: 'สำเร็จ',
            type: 'success'
          })
          vm.handleGetAdmin()
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    handleSuccess() {
      this.reset()
      this.handleCloseDialog()
    },
    handleCloseDialog() {
      this.selectedAdmin = null
      this.showAdminManageDialog = false
    },
    changePage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit
        vm.handleGetAdmin()
      }
    },
    getBranchName(id) {
      let tempBranch = ''
      if (id && this.branchList) {
        tempBranch = this.branchList.find((item) => {
          return item.branch_id == id
        })
      }

      return tempBranch ? tempBranch.branch_name : '-'
    },
    getRoleName(item) {
      let name = '-'
      if (item) {
        const privilege = JSON.parse(item)
        switch (privilege.role) {
          case 'approver':
            name = 'พนักงานอนุมัติ'
            break
          case 'supervisor':
            name = 'หัวหน้าศูนย์'
            break
          case 'superadmin':
            name = 'Superadmin'
            break
        }
      }
      return name
    },
    onSearch(payload) {
      this.filter = { ...payload }
      this.reset()
      this.handleCloseSearch()
    },
    handleCloseSearch() {
      this.showSearch = false
    },
    reset() {
      this.offset = 0
      this.pagetmp = 1
      this.pageNumber = 1
      this.handleGetAdmin()
    },
    handleChangeSort() {
      this.reset()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/YasaleAc/AdminManagement.vue